import { Component, Vue } from 'vue-property-decorator';
import bannersStore from '@/store/banners';
import { Banner } from '@/models';

@Component
export default class BannersBar extends Vue {

   private async created() {
      if (!bannersStore.currentBannersLoaded) {
         await this.fetchBannersAsync();
      }
   }

   private get bannerLeft(): Banner {
      return bannersStore.bannerLeft || bannersStore.emptyBanner;
   }

   private get bannerCenter(): Banner {
      return bannersStore.bannerCenter || bannersStore.emptyBanner;
   }

   private get bannerRight(): Banner {
      return bannersStore.bannerRight || bannersStore.emptyBanner;
   }

   private async fetchBannersAsync() {
      await bannersStore.fetchCurrentBannersAsync();
   }

   private getImageUrl(banner: Banner) {
      if (banner.url) {
         return `${banner.url}?height=100&mode=crop`;
      }
      return '/content/banners/empty-banner.jpg';
   }
}
